<script setup lang="ts">
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  icon?: string
  text: string
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <div class="inline-flex items-center" v-bind="$attrs">
    <div
      class="flex items-center rounded-2xl bg-linear-to-b from-black to-black/80 inset-ring-2 inset-ring-black/30 dark:bg-gray-800 px-3 py-1.5"
    >
      <SvgIcon :path="icon" class="fill-white me-1 h-5 w-5" />
      <span class="font-medium text-xs text-white">{{ text }}</span>
    </div>
  </div>
</template>
